import { useRouter } from "next/router";
import React from "react";

import { AvatarWithFallback } from "@/features/user/components/avatar/AvatarWithFallBack";
import { getUserProfilePath } from "@/helpers/common/path";

interface CommentAvatarProps {
  avatarUrl: string;
  displayName: string;
  accountName: string;
}
export const CommentAvatar: React.FC<CommentAvatarProps> = (props) => {
  const { avatarUrl, displayName, accountName } = props;
  const router = useRouter();
  const onClick = () => {
    if (!accountName) return;
    router.push(getUserProfilePath(accountName));
  };

  return (
    <div onClick={onClick}>
      <AvatarWithFallback
        accountName={accountName}
        sizeClassName="avatar-36 touchable"
        avatarUrl={avatarUrl}
        displayName={displayName}
      />
    </div>
  );
};
